import "./admin_dashboard.scss";

import { useState, useEffect } from "react";
import DragContainer from "./Draggable/DragContainer";
import { automateFactory } from "../../../automation/automation";
import { useAuth } from "../../../authentication/authHelpers";
import axios from "axios";
import dayjsTZ from "../../../utils/dayjs";

const AUTOMATION_KEY = "flexhr_requestsToApprovals_ran";

function AdminDashboard() {
  const [alreadySent, setAlreadySent] = useState(false);
  const auth = useAuth();

  useEffect(() => {
    if (alreadySent || !auth) return undefined;

    const today = dayjsTZ().format("YYYY-MM-DD");
    try {
      if (localStorage.getItem(AUTOMATION_KEY) === today) {
        setAlreadySent(true);
        return undefined;
      }
    } catch (_e) {
      // ignore storage errors
    }

    let cancelled = false;
    const run = async () => {
      let ip = "";
      try {
        const res = await axios.get("https://api.ipify.org/?format=json");
        ip = res?.data?.ip || "";
      } catch (_e) {
        // IP is optional for automation; do not block.
      }
      if (cancelled) return;
      try {
        await automateFactory("requestsToApprovals", auth, {
          Ipv4: ip,
        });
        try {
          localStorage.setItem(AUTOMATION_KEY, today);
        } catch (_e) {
          // ignore
        }
      } catch (err) {
        console.log(
          "THere was an error in the tasks converter requestsToApprovals",
          err
        );
      } finally {
        if (!cancelled) setAlreadySent(true);
      }
    };

    const idle =
      typeof window !== "undefined" && window.requestIdleCallback
        ? window.requestIdleCallback(() => run(), { timeout: 2500 })
        : null;
    const timeoutId =
      idle == null ? window.setTimeout(run, 0) : null;

    return () => {
      cancelled = true;
      if (idle != null && window.cancelIdleCallback) {
        window.cancelIdleCallback(idle);
      }
      if (timeoutId != null) clearTimeout(timeoutId);
    };
  }, [auth, alreadySent]);

  return (
    <div className="admin-dashboard">
      <DragContainer view={"Admin"} floatingHeader={true} />
    </div>
  );
}

export default AdminDashboard;
